(() => {
  const feedback = document.querySelector('[data-hv-purchase-feedback]');
  if (!feedback) return;
  let queue = Promise.resolve();
  let feedbackTimer;
  const text = feedback.dataset;
  function showFeedback(message) {
    clearTimeout(feedbackTimer);
    feedback.querySelector('[data-hv-feedback-message]').textContent = message;
    feedback.hidden = false;
    feedbackTimer = setTimeout(() => { feedback.hidden = true; }, 10000);
  }
  feedback.querySelector('[data-hv-feedback-close]').addEventListener('click', () => { feedback.hidden = true; });
  feedback.addEventListener('focusin', () => clearTimeout(feedbackTimer));
  function renderCart(html) {
    if (!html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    let updated = 0;
    for (const selector of ['#cart-icon-bubble .cart-wrapper', '#cart_reload']) {
      const target = document.querySelector(selector);
      const source = doc.querySelector(selector);
      if (target && source) {
        target.replaceChildren(...Array.from(source.childNodes, node => document.importNode(node, true)));
        updated++;
      }
    }
    return updated === 2;
  }
  async function refreshCart(html, sectionId) {
    if (renderCart(html)) return;
    const url = new URL(location.href);
    url.searchParams.set('section_id', sectionId);
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok || !renderCart(await response.text())) throw new Error('Cart refresh failed');
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('.hv-purchase__options[open]');
    if (details) { details.open = false; details.querySelector('summary').focus(); }
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('form[data-hv-add]');
    if (!form || form.dataset.busy) return;
    const card = form.closest('[data-hv-purchase]');
    delete card.dataset.error;
    card.querySelector('[role="status"]').textContent = '';
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('form[data-hv-add]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy || !form.reportValidity()) return;
    const card = form.closest('[data-hv-purchase]');
    const message = card.querySelector('[role="status"]');
    const button = form.querySelector('button[type="submit"]');
    const label = button.textContent;
    const body = new FormData(form);
    const header = document.querySelector('#cart-icon-bubble')?.closest('[id^="shopify-section-"]');
    const sectionId = header?.id.replace('shopify-section-', '') || 'header';
    body.set('sections', sectionId);
    body.set('sections_url', location.pathname + location.search);
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = text.adding;
    message.textContent = '';
    delete card.dataset.error;
    queue = queue.catch(() => {}).then(async () => {
      let added = false;
      let received = false;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body
        });
        const data = await response.json();
        received = true;
        if (!response.ok || data.status) throw new Error(data.description || data.message || text.error);
        added = true;
        message.textContent = text.added;
        button.textContent = text.added;
        showFeedback(text.added);
        await refreshCart(data.sections?.[sectionId], sectionId);
        document.dispatchEvent(new CustomEvent('hv:cart-updated'));
      } catch (error) {
        const description = added ? text.refresh : received ? error.message : text.uncertain;
        card.dataset.error = 'true';
        message.textContent = description;
        if (added || !received) showFeedback(description);
      } finally {
        delete form.dataset.busy;
        form.removeAttribute('aria-busy');
        button.disabled = false;
        button.textContent = label;
      }
    });
  });
})();
